module.exports = __webpack_public_path__ + "static/media/account_circle.62713972.svg";